// @flow
import React from 'react';
import styled from 'styled-components';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import LegalPerson from 'AssetsRoot/images/homie_v3/legal_person.svg.react';
import DownArrow from 'AssetsRoot/images/homie_v3/down_arrow.svg.react';
import NaturalPerson from 'AssetsRoot/images/homie_v3/natural_person.svg.react';
import { media } from 'styles/Mixins';
import { NATURAL_PERSON, LEGAL_PERSON } from 'utils/Constants';
import * as Layout from 'styles/Layout';

const ApplicationContainer = styled(Layout.FlexColumn)`
  width: 100%;
  position: relative;
`;

const CancelAppButton = styled(RenterApp.CancelAppButton)`
  height: auto;
  min-height: 17px;
  margin: 60px auto 10px auto;
  ${media.md`
    margin: 0;
  `}
`;

const TextTitle = styled.span`
  min-height: 19px;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
`;

const Subtitle = styled(TextTitle)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const TypesClientContainer = styled(Layout.FlexRow)`
  width: 270px;
  margin: 0 auto;
  ${media.md`
    width: 298px;
  `}
`;

const TypeClientContainer = styled(Layout.FlexColumn)`
  width: 123px;
`;

const TypeClientCard = styled(Layout.FlexColumn)`
  height: 132px;
  width: 120px;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0);
  border: 1px solid #cdcdcd;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s linear;
  color: #4a4a4a;
  &.selected {
    color: #fff;
    background-color: #278c7e !important;
    svg g {
      fill: #fff;
    }
  }
  &:hover {
    background-color: #ededed;
  }
  ${media.md`
    border: 0 solid #CDCDCD;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  `}
`;

const NaturalPersonIcon = styled(NaturalPerson)`
  height: 49px;
  width: 32px;
`;

const LegalPersonIcon = styled(LegalPerson)`
  height: 49px;
  width: 43px;
`;

const TypeClientName = styled.span`
  height: 19px;
  font-size: 16px;
  line-height: 19px;
  margin-top: 20px;
`;

const DocumentRequiredTitle = styled(Layout.FlexRow)`
  align-items: center;
  margin-top: 10px;
  pointer-events: all;
  cursor: pointer;
  ${media.md`
    pointer-events: none;
    cursor: default;
  `}
`;

const DocumentRequiredTitleText = styled.span`
  color: #000;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  ${media.md`
    color: #4a4a4a;
    font-weight: bold;
  `}
`;

const IconContainer = styled.div`
  display: block;
  margin-right: 13px;
  transition: transform 0.2s ease-out;
  transform: ${props => (props.isopen ? 'rotate(180deg)' : 'rotate(0)')};
  ${media.md`
    display: none;
  `}
`;

const DownArrowIcon = styled(DownArrow)`
  display: block;
  height: 8px;
  width: 13px;
  & path {
    fill: #000;
  }
`;

const DocumentsRequiredContainer = styled(Layout.FlexColumn)`
  overflow-y: hidden;
  max-height: ${props => (props.isopen ? '210px' : '0')};
  transition: max-height 0.2s ease-out;
  ${media.md`
    max-height: 210px;
    transition: max-height 0s ease-out;
  `}
`;

const DocumentRequired = styled.span`
  color: #4a4a4a;
  font-size: 13px;
  line-height: 17px;
  margin-top: 10px;
`;

const BannerContainer = styled.div`
  align-items: center;
  background: #fff;
  box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 10%);
  border-left: 5px solid #278c7e;
  display: flex;
  padding: 0.75em;

  @media screen and (min-width: 980px) {
    margin-top: 40px;
  }
`;

const BannerText = styled.p`
  color: #6f6f6f;
  font-weight: 700;
  font-size: 12px;
  line-height: 27px;
  margin: 0 0 0 1.5em;
`;

type PropsType = {
  handleChange: any => void,
  onCancel: () => void,
  typePersonSelected: string | typeof undefined
};

type StateType = {
  isOpenDropDownNaturalPerson: boolean,
  isOpenDropDownLegalPerson: boolean
};

export default class ApplicationContent extends React.Component<
  PropsType,
  StateType
> {
  state = {
    isOpenDropDownNaturalPerson: false,
    isOpenDropDownLegalPerson: false
  };

  toggleDropDownNaturalPerson = (): void => {
    this.setState({
      isOpenDropDownNaturalPerson: !this.state.isOpenDropDownNaturalPerson
    });
  };

  toggleDropDownLegalPerson = (): void => {
    this.setState({
      isOpenDropDownLegalPerson: !this.state.isOpenDropDownLegalPerson
    });
  };

  changeTypePerson = (value: number): void => {
    this.props.handleChange({
      person_type: value,
      user: { person_type: value }
    });
  };
  render() {
    const { typePersonSelected } = this.props;
    return (
      <ApplicationContainer>
        <BannerContainer>
          <BannerText>
            Esta aplicación tiene un costo de $1,199 MXN y solo se te cobra si
            rentas un inmueble con nosotros.
          </BannerText>
        </BannerContainer>
        <Subtitle>Aplicar como:</Subtitle>
        <TypesClientContainer>
          <TypeClientContainer>
            <TypeClientCard
              onClick={() => this.changeTypePerson(NATURAL_PERSON)}
              className={
                typePersonSelected === NATURAL_PERSON ? 'selected' : ''
              }
            >
              <NaturalPersonIcon />
              <TypeClientName>Persona física</TypeClientName>
            </TypeClientCard>
            <DocumentRequiredTitle
              onClick={() => this.toggleDropDownNaturalPerson()}
            >
              <DocumentRequiredTitleText>
                Documentos requeridos:
              </DocumentRequiredTitleText>
              <IconContainer isopen={this.state.isOpenDropDownNaturalPerson}>
                <DownArrowIcon />
              </IconContainer>
            </DocumentRequiredTitle>
            <DocumentsRequiredContainer
              isopen={this.state.isOpenDropDownNaturalPerson}
            >
              <DocumentRequired>Identificación oficial</DocumentRequired>
              <DocumentRequired>
                Comprobantes de ingresos de los últimos 3 meses
              </DocumentRequired>
            </DocumentsRequiredContainer>
          </TypeClientContainer>
          <Layout.Spacer />
          <TypeClientContainer>
            <TypeClientCard
              onClick={() => this.changeTypePerson(LEGAL_PERSON)}
              className={typePersonSelected === LEGAL_PERSON ? 'selected' : ''}
            >
              <LegalPersonIcon />
              <TypeClientName>Persona moral</TypeClientName>
            </TypeClientCard>
            <DocumentRequiredTitle
              onClick={() => this.toggleDropDownLegalPerson()}
            >
              <DocumentRequiredTitleText>
                Documentos requeridos:
              </DocumentRequiredTitleText>
              <IconContainer isopen={this.state.isOpenDropDownLegalPerson}>
                <DownArrowIcon />
              </IconContainer>
            </DocumentRequiredTitle>
            <DocumentsRequiredContainer
              isopen={this.state.isOpenDropDownLegalPerson}
            >
              <DocumentRequired>Identificación oficial</DocumentRequired>
              <DocumentRequired>
                <strong>Empresa</strong>
              </DocumentRequired>
              <DocumentRequired>
                Identificación oficial vigente de representante legal
              </DocumentRequired>
              <DocumentRequired>
                Acta constitutiva de la empresa
              </DocumentRequired>
              <DocumentRequired>
                Última declaración anual de la empresa
              </DocumentRequired>
            </DocumentsRequiredContainer>
          </TypeClientContainer>
        </TypesClientContainer>
        <CancelAppButton onClick={this.props.onCancel}>
          Cancelar aplicación
        </CancelAppButton>
      </ApplicationContainer>
    );
  }
}
